import { METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import successMessages from 'network/messages/successMessages'

export const placeBetCrashGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/crash-game/place-bet-crash-game', data, {
    server: microServices.SERVICE_URL_1,
    successMessage: successMessages.betPlacedSuccessfully
  })
}
export const escapeCrashBetService = ({ betId, timeStamp }) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/crash-game/player-escape-crash-game', { betId }, {
    server: microServices.SERVICE_URL_1,
    timeStamp
  })
}

export const cancelCrashBetService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/crash-game/cancel-bet-crash-game', data, {
    server: microServices.SERVICE_URL_1,
    successMessage: successMessages.betCancelledSuccessfully
  })
}
export const getAllRoundHistoryService = () => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/crash-game/get-crash-game-history', {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyBetsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/crash-game/my-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}
export const getPreviousRoundBetsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/crash-game/previous-round-placed-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getTopBetsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/crash-game/top-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const verifyProvableFairCrashService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/crash-game/check-provable-fair', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyStatsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/crash-game/my-stats', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}
